import axios from 'axios'

export const getBuildingTypes = (id: string) =>
  axios.get(`hu/Building/client/${id}/buildingtypes`, {
    headers: { 'x-api-version': '2.0' },
  })
